/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';
import AccountApi from '../../../services/accountapi';


import {
  Card, CardImg, CardText, CardBody,
  CardTitle, Breadcrumb, BreadcrumbItem, Button, Modal, ModalHeader, ModalBody, Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm, Errors, Field } from 'react-redux-form';
import ItemModal from './customModal';
import reservationStore from '../../../stores/reservation-store';
import Api from '../../../services/reservationapi';
import { ClipLoader } from 'react-spinners';
import accountStore from '../../../stores/account-store';


class RefundConfirMation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      Jumper_id: '',
      errors: '',
      amount: this.props.transactionAmount,
      transactionId: this.props.transactionId,
      isloading: false
    }
  }


  toggleModal = (e) => {
    //alert();
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  }

  handleInput = (e) => {
    this.setState({
      amount: e.target.value
    })
  }


  clickRefund = (value) => {
    this.setState({
      isloading: true
    })

    const { chargeValue, jumperId } = this.props;

    console.log(this.props.chargeValue);

    if (chargeValue.transactionType === "Cash") {
      var body = {
        transactionType: chargeValue.transactionType,
        transactionId: chargeValue.transactionId,
        amount: -chargeValue.amount,
        isRefund: true
      };
      accountStore.ChargeJumper(jumperId, body);
      this.setState({
        isloading: false
      })
      this.toggleModal();
    }
    else if (chargeValue.transactionType === "Card key in" || chargeValue.transactionType === "Card On File") {
      var amount = chargeValue.amount;
      var tId = chargeValue.transactionId;
      this.transactionId = tId;
      if (tId != "") {
        var body = AccountApi.cancelAuthorizeCaptureBody(tId);
        var response = Api.cancelAuthorizeAndCapture(reservationStore.getTokenVal(), reservationStore.getServiceId(), tId, body).then(this.processUndoResponse);
      }
    }

    // var body = {
    //   transactionType : charge.transactionType,
    //   transactionId : charge.transactionId,
    //   amount: -charge.amount,
    //   isRefund: true
    // };

    // if(charge.transactionType === "Cash"){	
    //   accountStore.ChargeJumper(this.state.jumperId, body);
    // }

    // var amount = this.props.transactionAmount;
    // var tId = this.props.transactionId;
    // this.transactionId = tId;
    // if (tId != "") {
    //   var body = AccountApi.cancelAuthorizeCaptureBody(tId);
    // 	var response = Api.cancelAuthorizeAndCapture(reservationStore.getTokenVal(), reservationStore.getServiceId(), tId, body).then(this.processUndoResponse);
    // }
    // else {
    // }
  }

  processPaymentResponse = (r) => {
    if (r.data !== undefined && r.data.Status === "Successful") {
      alert('Refund Successfully');
      const { chargeValue, jumperId } = this.props;

      console.log(this.props.chargeValue);

      var body = {
        transactionType: chargeValue.transactionType,
        transactionId: chargeValue.transactionId,
        amount: -chargeValue.amount,
        isRefund: true
      };
      accountStore.ChargeJumper(jumperId, body);
    }
    else {
      alert('something failed, please try again');
    }
    this.setState({
      isloading: false,
      isModalOpen: false
    })
  }

  processUndoResponse = (r) => {
    console.log(this.props.charge);
    if (r.status !== undefined && r.status === 200) {
      alert('Refund Successfully');
      const { chargeValue, jumperId } = this.props;

      console.log(this.props.chargeValue);

      var body = {
        transactionType: chargeValue.transactionType,
        transactionId: chargeValue.transactionId,
        amount: -chargeValue.amount,
        isRefund: true
      };
      accountStore.ChargeJumper(jumperId, body);

    }
    else {
      if (r.status === 400) {
        var transactionId = this.props.transactionId;
        var amount = this.props.transactionAmount.toFixed(2);
        var body = AccountApi.transferAuthorizeCaptureBody(transactionId, amount);
        var response = Api.authorizeAndCapture(reservationStore.getTokenVal(), reservationStore.getServiceId(), body).then(this.processPaymentResponse);
      }
    }
    this.setState({
      isloading: false,
      isModalOpen: false
    })
  }

  render() {
    const override = `
      display: block;
      margin: 0 auto;
      border-color: red;
    `;

    return (
      <React.Fragment>
        <ItemModal
          isModalOpen={this.state.isModalOpen}
          title={`Charge Jumper`}
        >

          <div className='complete-loading'>
            <ClipLoader
              css={override}
              sizeUnit={"px"}
              size={35}
              color={'#fff'}
              loading={this.state.isloading}
            />
          </div>

          <LocalForm onSubmit={(values) => this.clickRefund(values)}>

            <Row className="form-group">
              <Col md={12}>
                <span>Are you Sure you Want to Refund ?</span>
              </Col>
            </Row>

            <Row className="form-group m-t-2-rem">
              <Col md={{ size: 9 }}>
                <button className="btn btn-bg lightColor createButton" type="submit" >SUBMIT</button>
                <button onClick={(e) => { e.preventDefault(); this.toggleModal(); }} className="btn btn-link">CANCEL</button>
              </Col>
            </Row>

          </LocalForm>
        </ItemModal>

        {/* <button className="btn customButton rightButton" style={{ borderRadius: '4px', backgroundColor: '#A7F6FF', color: '#082764' }} onClick={() => this.toggleModal()}>
          Refund
				</button> */}
        <button className="btn lightBlueButton" onClick={() => this.toggleModal()}>
          <i className="fa fa-undo" />
        </button>
      </React.Fragment>
    );
  }
}

export default RefundConfirMation